import { isProduction } from "./env";
import { prodConfig } from '../config'

export const URL = {
  WK_API_BASE_URL: isProduction() ?  `${prodConfig.BASE_URL}/api` : 'http://dbg.weike.fm/api',
  WK_PAGE_BASEURL: isProduction() ? prodConfig.MAIN_URL : 'http://dbg.lizhiweike.com'
}


// WEBPACK FOOTER //
// ./src/core/url.js